import LoaderEye from 'components/shared/LoaderEye/LoaderEye';
import React, { useEffect } from 'react';
import styles from './Redirect.module.scss'

function Redirect() {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = '/';
    }, 3000)
  }, [])
  return (
    <div className={styles.div}>
      <LoaderEye />
    </div>
  )
}

export default Redirect
